'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isDark = require('./is-dark');

var _isDark2 = _interopRequireDefault(_isDark);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getColorFill = function getColorFill(colors) {
  return function () {
    var fill = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

    var color = colors[fill] || colors.default;

    return {
      color: (0, _isDark2.default)(color) ? colors.white : colors.black,
      backgroundColor: color,
      borderColor: color
    };
  };
};

exports.default = getColorFill;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/util/get-color-fill.js
// module id = Yng2
// module chunks = 1